<template>
<section class="banner__breadcumn ralt">

        <!--Search Popup-->
        <div id="searchPopup" class="search__popup">
            <form action="#" class="popup-content d-flex align-items-center">
                <input type="text" placeholder="Search Here">
                <button id="closeButton">
                    <i class="bi bi-x-lg"></i>
                </button>
            </form>
        </div>
        <!--Search Popup-->
        <div class="breadcumnd__wrapper">
            <div class="container">
                <div class="profile__wrapper">
                    <div class="row g-4 align-items-center justify-content-between">
                        <div class="col-xxl-6 col-xl-6 col-lg-7 col-md-7 col-sm-7">
                            <div class="breadcumnd__content">
                                <span class="d41 mb-24">
                                    Korrupsiyaga Qarshi Kurashish
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  <div class="article-list">
    <h1 class="title">Korrupsiya holatlari haqiqa xabar berish uchun bog'lanish raqami "1165"</h1>

    <div class="management-section">

      <ul class="management-list">
        <li>
         <a href=https://uz.post/storage/media/45-son%20buyruq%2012%20aprel.pdf>
            "O'zbekiston pochtasi" AJ xodimlarining korrupsiyaga oid huquqbuzarliklarni sodir etishga undash holatlari haqida xabar berish, ularni ro'yxatga olish, ko'rib chiqish hamda ularga qarshi kurashishdagi xodimlarning faol ishtiroki uchun rag'batlantirish to'g'risidagi tartibini tasdiqlash to'g'risida
        </a>
        </li>
        <li>
          <a href=https://uz.post/storage/media/2.%20%E2%80%9C%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD%20%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8%E2%80%9D%20%D0%B0%D0%BA%D1%86%D0%B8%D1%8F%D0%B4%D0%BE%D1%80%D0%BB%D0%B8%D0%BA%20%D0%B6%D0%B0%D0%BC%D0%B8%D1%8F%D1%82%D0%B8%20%D1%85%D0%BE%D0%B4%D0%B8%D0%BC%D0%BB%D0%B0%D1%80%D0%B8%D0%BD%D0%B8%D0%BD%D0%B3.pdf>
          "O'zbekiston pochtasi" AJ xodimlarining odob-axloq qoidalari
          </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/3.%20%E2%80%9C%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD%20%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8%E2%80%9D%20%D0%B0%D0%BA%D1%86%D0%B8%D1%8F%D0%B4%D0%BE%D1%80%D0%BB%D0%B8%D0%BA%20%D0%B6%D0%B0%D0%BC%D0%B8%D1%8F%D1%82%D0%B8%D0%BD%D0%B8%D0%BD%D0%B3%20%D0%9E%D0%B4%D0%BE%D0%B1-%D0%B0%D0%BB%D0%BE%D2%9B,%20%D0%BC%D0%B5%D2%B3%D0%BD%D0%B0%D1%82%20%D0%BD%D0%B8%D0%B7%D0%BE%D1%81%D0%B8%20%D0%B2%D0%B0%20%D0%BA%D0%BE%D1%80%D1%80%D1%83%D0%BF%D1%86%D0%B8%D1%8F%D0%B3%D0%B0%20%D2%9B%D0%B0%D1%80%D1%88%D0%B8%20%D0%BA%D1%83%D1%80%D0%B0%D1%88%D0%B8%D1%88%20%D0%BA%D0%BE%D0%BC%D0%B8%D1%81%D1%81%D0%B8%D1%8F%D1%81%D0%B8%20%D1%82%D1%9E%D2%93%D1%80%D0%B8%D1%81%D0%B8%D0%B4%D0%B0%D0%B3%D0%B8%20%D0%BD%D0%B8%D0%B7%D0%BE%D0%BC.pdf>
        "O'zbekiston pochtasi" AJ ning odob-axloq, mehnat nizosi va korrupsiyaga qarshi kurashish komissiyasi nizomi
        </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/4.%20%E2%80%9C%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD%20%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8%E2%80%9D%20%D0%B0%D0%BA%D1%86%D0%B8%D1%8F%D0%B4%D0%BE%D1%80%D0%BB%D0%B8%D0%BA%20%D0%B6%D0%B0%D0%BC%D0%B8%D1%8F%D1%82%D0%B8%D0%BD%D0%B8%D0%BD%D0%B3%20%D0%BA%D0%BE%D1%80%D1%80%D1%83%D0%BF%D1%86%D0%B8%D1%8F%D0%B3%D0%B0%20%D0%BE%D0%B8%D0%B4.pdf>
        "O'zbekiston pochtasi" AJ ga korrupsiyaga oid kelib tushgan xabarlarni qabul qilish va qayta ishlash reglamenti
        </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/7.%20%20%E2%80%9C%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD%20%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8%E2%80%9D%20%D0%B0%D0%BA%D1%86%D0%B8%D1%8F%D0%B4%D0%BE%D1%80%D0%BB%D0%B8%D0%BA%20%D0%B6%D0%B0%D0%BC%D0%B8%D1%8F%D1%82%D0%B8%20%D0%9A%D0%BE%D1%80%D1%80%D1%83%D0%BF%D1%86%D0%B8%D1%8F%D0%B3%D0%B0%20%D2%9B%D0%B0%D1%80%D1%88%D0%B8%20%D0%BA%D1%83%D1%80%D0%B0%D1%88%D0%B8%D1%88%20%D1%81%D0%B8%D1%91%D1%81%D0%B0%D1%82%D0%B8.pdf>
        "O'zbekiston pochtasi" AJ korrupsiyaga qarshi kurashish siyosati
        </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/5.%20%D0%9F%D0%9A%20Ozbekiston_pochtasi_AJ_da_korrupsiyaviy_xavf_xatarlarni_baholash_compressed.pdf>
        “O'zbekiston_pochtasi” AJ da_korrupsiyaviy xavf-xatarlarni baholash uslubiyoti
        </a>
        </li>
        <li>
        <a href="https://uz.post/storage/media/6.%20%D0%9F%D0%9A%20Komplaens%20xizmati%20to'g'risidagi%20nizom.pdf">
        "O'zbekiston pochtasi" AJ Korrupsiyaga qarshi komplaens xizmati to'g'risida"gi nizom
        </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/6.%20%D0%9F%D0%9A%20%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD_%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8_%D0%90%D0%96_%D0%BC%D0%B0%D1%80%D0%BA%D0%B0%D0%B7%D0%B8%D0%B9_%D0%B0%D0%BF%D0%BF%D0%B0%D1%80%D0%B0%D1%82%D0%B8%D0%B3%D0%B0_%D0%B8%D1%88%D0%B3%D0%B0_%D2%9B%D0%B0%D0%B1%D1%83%D0%BB_%D2%9B%D0%B8%D0%BB%D0%B8%D0%BD%D0%B0%D1%91%D1%82%D0%B3%D0%B0%D0%BD.pdf>
        "O'zbekiston pochtasi" AJ markaziy apparatiga ishga qabul qilinayotgan nomzodlarni tekshirish bo'yicha yo'riqnoma
        </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/7.%20%D0%9F%D0%9A%20%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD_%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8_%D0%90%D0%96_%D1%85%D0%BE%D0%B4%D0%B8%D0%BC%D0%BB%D0%B0%D1%80%D0%B8%D0%BD%D0%B8%D0%BD%D0%B3_%D0%BA%D0%BE%D1%80%D1%80%D1%83%D0%BF%D1%86%D0%B8%D1%8F%D0%B2%D0%B8%D0%B9_%D0%B2%D0%B0_%D0%B0%D2%B3%D0%BB%D0%BE%D2%9B_%D2%9B%D0%BE%D0%B8%D0%B4%D0%B0%D0%BB%D0%B0%D1%80%D0%B8%D0%BD%D0%B8.pdf>
        "O'zbekiston pochtasi" AJ hodimlarning korrupsiyaviy harakatlarni va odob ahloq qoidalarini buzish holatlari ustidan xizmat tekshiruvlari o'tkazish bo'yicha reglament
        </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/8.%20%D0%9F%D0%9A%20%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD_%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8_%D0%90%D0%96_%D1%85%D0%BE%D0%B4%D0%B8%D0%BC%D0%BB%D0%B0%D1%80%D0%B8%D0%BD%D0%B8%D0%BD%D0%B3_%D1%8D%D1%82%D0%B8%D0%BA%D0%B0_%D0%B2%D0%B0_%D0%BA%D0%BE%D1%80%D1%80%D1%83%D0%BF%D1%86%D0%B8%D1%8F%D0%B3%D0%B0_%D2%9B%D0%B0%D1%80%D1%88%D0%B8_%D0%BA%D1%83%D1%80%D0%B0%D1%88%D0%B8%D1%88.pdf>
        "O'zbekiston pochtasi" AJ xodimlarning odob-axloq qoidalari va korrupsiyaga qarshi kurashish sohasida o'qitilishini tashkil qilish bo'yicha yo'riqnoma
        </a>
        </li>
        <li>
        <a href=https://uz.post/storage/media/9_%D0%8E%D0%B7%D0%B1%D0%B5%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD_%D0%BF%D0%BE%D1%87%D1%82%D0%B0%D1%81%D0%B8_%D0%BA%D0%BE%D0%BD%D1%82%D1%80%D0%B0%D0%B3%D0%B5%D0%BD%D1%82%D0%BB%D0%B0%D1%80%D0%BD%D0%B8_%D1%82%D0%B5%D0%BA%D1%88%D0%B8%D1%80%D0%B8%D1%88%D0%B3%D0%B0_%D0%BE%D0%B8%D0%B4_%D0%B9%D1%9E%D1%80%D0%B8%D2%9B%D0%BD%D0%BE%D0%BC%D0%B0.pdf>
        "O'zbekiston pochtasi" AJda kontragentlarni tekshirishga oid yo‘riqnoma
        </a>
        </li>
        <li>
        <a href="https://uz.post/storage/media/11.%20Manfaatlar%20to'qnashuvi%20boshqarish%20nizomi.pdf">
        Manfaatlar to'qnashuvi boshqarish nizomi
        </a>
        </li>
        <li>
        <a href="https://uz.post/storage/media/13.%20Davlat%20haridlarini%20AJda%20o'tkazish%20bo'yicha%20nizom.pdf">
        Davlat haridlarini AJda o'tkazish bo'yicha nizom
        </a>
        </li>
        <li>
        <a href="https://uz.post/storage/media/14.%20Komplaens%20hisobotlarini%20AJda%20shakllantirish%20bo'yicha%20nizom.pdf">
       Komplaens hisobotlarini AJda shakllantirish bo'yicha nizom
        </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.article-list {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #f8f9ff;
  border-radius: 8px;
  font-family: system-ui, -apple-system, sans-serif;
}

.title {
  color: #1a47b8;
  font-size: 1.8rem;
  margin-bottom: 1.5rem;
  line-height: 1.3;
  font-weight: 600;
}

.description {
  color: #333;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
}

.subtitle {
  color: #333;
  font-size: 1.3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.management-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.management-list li {
  color: #333;
  font-size: 1.1rem;
  padding: 0.5rem 0;
  position: relative;
  padding-left: 1.5rem;
  transition: transform 0.2s ease;
}

.management-list li:hover {
  transform: translateX(5px);
}

.management-list li::before {
  content: "-";
  position: absolute;
  left: 0;
  color: #1a47b8;
}

@media (max-width: 768px) {
  .container {
    padding: 1rem;
    margin: 1rem;
  }

  .title {
    font-size: 1.5rem;
  }

  .description, .management-list li {
    font-size: 1rem;
  }
}
</style>